import styled from 'styled-components';

export const CreateUserButtonWrapper = styled.div`
  margin-bottom: 24px;
`;

export const FormField = styled.div`
  margin-bottom: 20px;
`;

export const SelectLabel = styled.label`
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: ${(props) => props.theme['color.text.body']};
`;

export const WorkspaceDropdownWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const WorkspaceSelectTrigger = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 8px 10px;
  font-size: 14px;
  text-align: left;
  border: 1px solid ${(props) => props.theme['color.grayLight']};
  border-radius: 4px;
  background: ${(props) => props.theme['color.background']};
  color: ${(props) => props.theme['color.text.body']};
  box-sizing: border-box;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
    min-width: 0;
  }
`;

export const WorkspaceOptionsPanel = styled.div`
  position: absolute;
  bottom: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 1000;
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid ${(props) => props.theme['color.grayLight']};
  border-radius: 4px;
  background: ${(props) => props.theme['color.grayLightest'] || '#f5f5f5'};
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.12);
`;

export const WorkspaceOptionItem = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  font-size: 14px;
  font-weight: ${(props) => props.selected ? '600' : 'normal'};
  color: ${(props) => props.theme['color.text.body']};
  cursor: pointer;
`;

export const ReadOnlyInput = styled.input`
  width: 100%;
  padding: 8px 10px;
  font-size: 14px;
  border: 1px solid ${(props) => props.theme['color.grayLight']};
  border-radius: 4px;
  background: ${(props) => props.theme['color.grayLightest'] || '#f5f5f5'};
  color: ${(props) => props.theme['color.text.body']};
  box-sizing: border-box;
`;
